import { JitsiMeeting } from '@jitsi/react-sdk';
import { Button } from 'components/button';
import KHCLottie from 'components/spinner/KHCLottie';
import { AppContext } from 'configuration/app-context';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createTestId } from 'utils';
import * as Redux from 'utils/redux-store';
import WebClient from 'utils/webclient';

var interval;

const VideoCallWindow = (props) => {

    const { translate, toastError, toastSuccess } = useContext(AppContext)
    const [jitsiApi, setjitsiApi] = useState(null)

    const [patient, setPatient] = useState(JSON.parse(sessionStorage.getItem("patient_data")))

    const [isNotify, setIsNotify] = useState(true)
    const [now, setNow] = useState(new Date().getTime())

    const member = useSelector((state) => state.member);
    const requesterType = 1;
    const videoCallState = useSelector(state => state.videoCall)
    const [onlineCallState, setOnlineCallState] = useState(null)
    const onlineCallInitializationValues = { callType: 1, callBackType: 0, isEmergencyCallAnswered: false, onlineCallId: videoCallState.url };

    const [onlineCall, setOnlineCall] = useState({})
    const [onlineCallJoinModel, setOnlineCallJoinModel] = useState({})

    function onlineCallStart() {
        var startModel = {
            requesterId: member.profileId,
            requesterType: requesterType,
            callbackType: onlineCallInitializationValues.callBackType,
            callType: onlineCallInitializationValues.callType,
            onlineCallId: onlineCallInitializationValues.onlineCallId ?? null
        }

        let cc = new WebClient()
        cc.post("5B3C6EB831DD570F8A84/Start", startModel, false, true)
            .then(({ isSuccess, data }) => {
                if (isSuccess) {

                    setOnlineCallState(true);
                }
                setOnlineCall(data);
            })
    }
    async function onlineCallJoin() {

        var joinModel = {
            onlineCallId: onlineCallInitializationValues.onlineCallId,
            onlineCallJoinId: onlineCall.onlineCallJoinId,
            requesterId: member.profileId,
            requesterType: requesterType,
            callbackType: onlineCallInitializationValues.callBackType,
            callType: onlineCallInitializationValues.callType,
        }

        let cc = new WebClient()
        const { isSuccess, data } = await cc.post("5B3C6EB831DD570F8A84/Join", joinModel, false, true);
        if (isSuccess) {
            setOnlineCallJoinModel(data);
            return data
        }
    }
    function onlineCallEnd(joinModel) {

        var endModel = {
            onlineCallId: joinModel !== null ? joinModel.onlineCallId : onlineCallJoinModel.onlineCallId,
            onlineCallJoinId: joinModel !== null ? joinModel.onlineCallJoinId : onlineCallJoinModel.onlineCallJoinId,
            requesterId: member.profileId,
            requesterType: requesterType,
            callbackType: onlineCallInitializationValues.callbackType,
            callType: onlineCallInitializationValues.callType,
        }

        let cc = new WebClient()
        cc.post("5B3C6EB831DD570F8A84/End", endModel, false, true)
            .then(({ isSuccess, data }) => {
                if (isSuccess) {

                    jitsiApi?.executeCommand('endConference');
                    jitsiApi?.dispose();
                    Redux.setVideoCallState(null);
                    setOnlineCall({});
                    setOnlineCallJoinModel({});
                }
            })
    }

    useEffect(() => {
        onlineCallStart();

        Redux.OnKhcSocket("joinDoctorAppointmentOnlineCall",
            (message) => {
                setOnlineCall(message);
                setOnlineCallState(true);
            },
            () => {
                console.log("error")
            }
        )

        Redux.OnKhcSocket("endOnlineCall",
            (message) => {
                jitsiApi?.executeCommand('endConference');
                jitsiApi?.dispose();
                Redux.setVideoCallState(null);
                setOnlineCall({});
                setOnlineCallJoinModel({});
                Redux.setVideoCallSurveyState({ vdeoCallGroupId: props?.videoCallUrl }) //doktor görüşmeyi tamamlandığında
            },
            () => {
                console.log("error")
            }
        )

        interval = setInterval(() => {
            setNow(new Date().getTime())
        }, 1000)

        return () => {
            clearInterval(interval)
        }
    }, []);

    const handleSendNotification = (appointmentId) => {
        let c = new WebClient()
        c.post("423B66B430FB75028A/NotifyClinician", { appointmentId }, true, true, true)
            .then(({ isSuccess, data, exception }) => {
                if (isSuccess) {
                    setIsNotify(false)
                    toastSuccess(translate("notify_sended_successful"))
                    clearInterval(interval)
                } else {
                    toastError(exception?.message ?? translate('unexpected_error_occurred'));
                }
            })
    }

    const appointmentDate = parseFloat(moment(props?.appointmentDate).format('x'))

    return (
        <div className="modal">
            <div className="modal-wrapper max-w-6xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="meeting">
                            {
                                onlineCallState ?
                                    <JitsiMeeting
                                        domain="meet.kochealthcare.org"
                                        roomName={onlineCallInitializationValues.onlineCallId}
                                        configOverwrite={{
                                            startWithAudioMuted: true,
                                            disableModeratorIndicator: true,
                                            startScreenSharing: false,
                                            enableEmailInStats: false,
                                            prejoinPageEnabled: true
                                        }}
                                        interfaceConfigOverwrite={{
                                            DISABLE_JOIN_LEAVE_NOTIFICATIONS: true
                                        }}
                                        userInfo={{
                                            displayName: patient?.fullName
                                        }}
                                        onApiReady={(externalApi) => {
                                            setjitsiApi(externalApi);

                                            let joinModel = {};

                                            externalApi.on("readyToClose", () => {
                                                externalApi.executeCommand('endConference');
                                                externalApi.dispose();
                                            });

                                            externalApi.on('videoConferenceJoined', async function (event) {

                                                joinModel = await onlineCallJoin();
                                            });
                                            externalApi.on('videoConferenceLeft', function (event) {

                                                onlineCallEnd(joinModel);
                                            });

                                            externalApi.on('incomingMessage', function (event) {
                                                //gelen mesaj
                                            });
                                            externalApi.on('outgoingMessage', function (event) {

                                                //gönderilen mesaj
                                                if (joinModel?.onlineCallJoinId) {
                                                    let cc = new WebClient()
                                                    cc.post("5B3C6EB831DD570F8A84/AddOnlineCallJoinAction", {
                                                        onlineCallJoinId: joinModel?.onlineCallJoinId,
                                                        requesterId: member.id,
                                                        requesterType: requesterType,
                                                        actionType: 8
                                                    }, false, true)
                                                        .then(({ isSuccess, data }) => {

                                                            if (isSuccess) {
                                                            }
                                                        })
                                                }
                                            });
                                            externalApi.on('videoAvailabilityChanged', function (event) {

                                                console.log(joinModel);
                                                //console.log(event);
                                                if (joinModel?.onlineCallJoinId) {
                                                    let cc = new WebClient()
                                                    cc.post("5B3C6EB831DD570F8A84/AddOnlineCallJoinAction", {
                                                        onlineCallJoinId: joinModel?.onlineCallJoinId,
                                                        requesterId: member.id,
                                                        requesterType: requesterType,
                                                        actionType: event.muted ? 6 : 7
                                                    }, false, true)
                                                        .then(({ isSuccess, data }) => {

                                                            if (isSuccess) {
                                                            }
                                                        })
                                                }
                                            });
                                            externalApi.on('videoMuteStatusChanged', function (event) {
                                                console.log(joinModel);
                                                if (joinModel?.onlineCallJoinId) {
                                                    let cc = new WebClient()
                                                    cc.post("5B3C6EB831DD570F8A84/AddOnlineCallJoinAction", {
                                                        onlineCallJoinId: joinModel?.onlineCallJoinId,
                                                        requesterId: member.id,
                                                        requesterType: requesterType,
                                                        actionType: event.muted ? 4 : 5
                                                    }, false, true)
                                                        .then(({ isSuccess, data }) => {

                                                            if (isSuccess) {
                                                            }
                                                        })
                                                }
                                            });
                                            externalApi.on('errorOccurred', function (event) {

                                                if (event.error) {
                                                    let cc = new WebClient()
                                                    cc.post("5B3C6EB831DD570F8A84/OnlineCallError", {
                                                        onlineCallJoinId: joinModel?.onlineCallJoinId,
                                                        requesterId: member.id,
                                                        requesterType: requesterType,
                                                        message: event.error?.message,
                                                        type: event.error?.type,
                                                    }, false, true)
                                                        .then(({ isSuccess, data }) => {

                                                            if (isSuccess) {
                                                            }
                                                        })
                                                }
                                            });
                                        }}
                                        getIFrameRef={(iframeRef) => {
                                            iframeRef.style.height = '100%';
                                        }} />
                                    :
                                    (
                                        <div className='flex flex-col items-center justify-center h-full gap-2'>
                                            <KHCLottie
                                                animationData='hourglass'
                                                lottieStyle='w-16 h-16'
                                            />
                                            <p className='text-center'>{translate('lobby_info')}</p>
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button
                            data-testid={createTestId('button', 'VideoCallWindow', 1)} onClick={async () => {
                                onlineCallEnd(onlineCallJoinModel);
                            }}
                            className="btn-gradient-secondary w-48"
                            label={translate("end_call")} />

                        {
                            (!onlineCallState && (now + 120000) > appointmentDate) && isNotify && (
                                <Button
                                    label={translate("notify_to_staff")}
                                    className="btn btn-gradient-primary w-48"
                                    data-testid={createTestId('button', 'VideoCallWindow', 2)} onClick={() => handleSendNotification(props?.appointmentId)} />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VideoCallWindow